import { Component } from '@angular/core';
import * as Constants from '@emi/shared/constants';

@Component({
  selector: 'via-about-euromonitor',
  templateUrl: './about-euromonitor.component.html',
  styleUrls: ['./about-euromonitor.component.scss']
})
export class AboutEuromonitorComponent {
  public passportProductPage = Constants.ExternalLinks.PASSPORT_PRODUCT_PAGE;
  public consultingProductPage = Constants.ExternalLinks.CONSULTING_PRODUCT_PAGE;
}
